import {
  KoBadge,
  KoButton,
  KoDateFormatter,
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoModal,
  KoNano,
  KoSelect,
  KoTabs,
  KoTag,
  KoText,
  KoTitle,
  KoToast,
  KoUpload,
  KoUserSelect,
  KoTooltips,
  KoRichTextEditor
} from 'packages';
import KoIcon from '@kwapio/icons';
import { useCallback, useEffect,  useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router';
import { TIMESPEND } from 'shared/commonConstants';
import { getSprints, getTicketTabCount } from "shared/store/slice";
import { getCookie } from 'shared/utils/cookies';
import { DevelopmentAPI } from "../development.service";
import { Date, Priority, Sprint } from './components';
import styles from './curd.module.scss';

import Comments from './comments';
import Attachemnts from './attachemnts';
import { getCurrentAssignees } from 'shared/store/currentAssigneesSlice';
import { resetState } from 'shared/store/tickettabCountSlice';

function EpicTaskCrud({ form, saveBtn, getIssueById,
  className, handleFinish, initialValues, epic, epicId }) {
  const { workspaceId } = useParams();
  const userById = useSelector(state => state?.userById);
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const ticketTabCount = useSelector(state => state?.ticketTabCount);
  const [currentWorkspaceId, setCurrentWorkspaceId] = useState(workspaceId);
  const [modulesList, setModulesList] = useState();
  const profile = currentAssignees['data'] || [];
  const [componentsList, setComponentsList] = useState();
  const [attachementsList , setAttachementsList] = useState([]);
  const [releaseList, setReleaseList] = useState();
  const [specList, setSpecList] = useState();
  const [workspace, setWorkspaceRecord] = useState();
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [lookupId, setLookupId] = useState();

  const [issueStates, setIssueStates] = useState(ticketTabCount['data']);
  const [isOpenCommentsModal, setCreateComment] = useState();
  const [ticketStates, setTicketStates] = useState();
  const [isLoading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  // const [filteredSlots, setFilteredSlots] = useState([]);
  const [customersList, setCustomersList] = useState();

  const dispatch = useDispatch();
  const StatusWatch = KoForm.useWatch('status', form);
  const spLink = KoForm.useWatch('specLink', form);
  const isCalendar = KoForm.useWatch('isCalendar', form) || false;
  let userDetails = userById['data'];


  const [pagination] = useState({
    size: 10000,
    offset: 0,
    page: 1
  });
    
  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form?.resetFields();
    } else {
      form?.setFieldsValue(initialValues);
    }
    setCurrentWorkspaceId(initialValues?.workspace);
  }, [initialValues, form]);


  useEffect(() => {
    if (spLink?.length > 0 && workspaceId) {
      const linkAll = async() => {
        try {
          await Promise.all(
            spLink.map(documentId =>
              DevelopmentAPI.linkToWorkspace(documentId, {
                projectLink: [workspaceId]
              })
            )
          );
        } catch (err) {
          console.error('Error linking specs to workspace:', err);
        }
      };

      linkAll();
    }
  }, [spLink, workspaceId]);



  useEffect(() => {
    if (initialValues?.workspace) {
      setCurrentWorkspaceId(initialValues?.workspace);
    }
  }, [initialValues?.workspace]);

  useEffect(() => {
    getSpecList(pagination);
    getClients(pagination);
    return () => {
      dispatch(resetState());
    };
  }, []);

  const getClients = (p) => {
    setLoading(true);
    DevelopmentAPI.getClients().then(
      (data) => {
        setCustomersList();
        setCustomersList(data['customers']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  useEffect(() => {
    getWorkFlow(initialValues?.epicId, initialValues?.workspace || currentWorkspaceId);
    if(initialValues?.epicId){
      DevelopmentAPI.getAttachments(initialValues?.epicId, workspaceId).then(
        (data) => {
          setLoading(false);
          setAttachementsList(data['attachments']);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      );
    }
    
  }, [initialValues?.epicId]);


  useEffect(() => {
    getWorkspaceById(currentWorkspaceId);
    if (currentAssignees['data'].length === 0) {
      dispatch(getCurrentAssignees(workspaceId));
    }
  }, [currentWorkspaceId]);

  useEffect(() => {
    if (initialValues?.epicId && currentWorkspaceId) {
      dispatch(getTicketTabCount({ workspaceId: currentWorkspaceId, ticketId: initialValues?.epicId }));
    }
  }, [initialValues?.epicId, currentWorkspaceId]);

  useEffect(() => {
    if (epic) {
      form.setFieldsValue({ issueType: 1, reporter: userDetails && userDetails?.userId });
    }
  }, [epic]);

  useEffect(() => {
    setIssueStates(ticketTabCount['data']);
  }, [ticketTabCount]);




  const getWorkFlow = (ticketId, wosId) => {
    let q={
      id:ticketId
    };
    DevelopmentAPI.getWorkFlowStatus(ticketId ? q : {}, wosId).then(
      (data) => {
        setTicketStates(data['status']);
      },
      (err) => {
      }
    );
  };

  const getWorkspaceById = (workspaceId) => {
    if (!workspaceId) {
      return;
    }
    DevelopmentAPI.getWorkspaceById(workspaceId).then(
      (data) => {
        setWorkspaceRecord(data['project']);
      },
      (err) => {
      }
    );

  };

  useEffect(() => {
    if ((StatusWatch === 10 || StatusWatch === 11) && workspace?.isPublic) {
      form.setFieldsValue({ assignee: initialValues?.reporter });
    }
  }, [StatusWatch]);

  useEffect(() => {
    if (currentWorkspaceId) {
      getModules();
      getComponents();
      getReleases();
      getSprintsList();
    }
  }, []);

  useEffect(() => {
    if (initialValues?.lookupId) {
      setLookupId(initialValues.lookupId);
    } else {
      const lp = KoNano('LOK');
      setLookupId(lp);
      let data = form?.getFieldsValue() || {};
      data['lookupId'] = lp;
      form?.setFieldsValue({ ...data });
    }

  }, [initialValues?.lookupId]);



  const updateTicektInfo = (info) => {
    setRefresh(false);
    let data = form?.getFieldsValue();
    if(!initialValues?.epicId){
      return;
    }
    const uniqueFiles = [...attachementsList, ...info].reduce((acc, file) => {
      const exists = acc.some(f => f.uid === file.uid);
      if (!exists) acc.push(file);
      return acc;
    }, []);

    data['attachments'] = uniqueFiles;
    form.setFieldsValue({ ...data });
    DevelopmentAPI.createOrUpdateIssues(data, initialValues?.epicId, workspaceId).then(
      (data) => {
        setRefresh(true);
        setLoading(false);
        setUploadFileModal(false);
        dispatch(getTicketTabCount({ workspaceId: workspaceId, ticketId: initialValues?.epicId }));
      },
      (err) => {
      }
    );
  };


  const getModules = () => {
    setModulesList();
    DevelopmentAPI.getModules(null, currentWorkspaceId).then(
      (data) => {
        setModulesList(data?.modules);
      },
      (err) => {
      }
    );
  };

  const getSpecList = (searchText) => {
    DevelopmentAPI.getDocuments(pagination, null, currentWorkspaceId).then(
      (data) => {
        setSpecList(data?.files);
      },
      (err) => {
      }
    );
  };

  const getSprintsList = () => {
    if (!currentWorkspaceId) {
      return;
    }
    dispatch(getSprints({ query: null, workspaceId: currentWorkspaceId }));
  };

  const getComponents = () => {
    setComponentsList();
    DevelopmentAPI.getComponents(null, currentWorkspaceId).then(
      (data) => {
        setComponentsList(data?.components);
      },
      (err) => {
      }
    );
  };

  const getReleases = () => {
    setReleaseList();
    DevelopmentAPI.getReleases(workspaceId).then(
      (data) => {
        setReleaseList(data?.releases);
      },
      (err) => {
      }
    );
  };



  const handleSubmit = useCallback(values => {
    values['lookupId'] = lookupId;
    values['type'] = 'epic';
    handleFinish(values, epicId);
  });

  const optionGroups = [];
  for (let i = 10; i < 36; i++) {
    optionGroups.push({
      label: i.toString(36) + i,
      value: i.toString(36) + i
    });
  }
  const TaskStatus = ({ value, onChange }) => (
    <KoSelect
      value={ticketStates?.length > 0 ? value :''}
      showSearch
      defaultValue={ticketStates?.length > 0 ? ticketStates[0].value : ''}
      onChange={v => onChange(v)}
      placeholder='Select status'
      options={ticketStates}
      optionRender={(option) => {
        const label = option?.data?.label;
        const formattedLabel = typeof label === 'string' ? label.replace(" ", '') : '';
        return (
          <div className={styles.statusWrapper} >
            <div style={{borderColor: option?.data?.color}} className={`${styles.status} ${styles[formattedLabel]}`} role="img" aria-label={label} />
            <KoText text={label} />
          </div>
        );
      }}
    />
  );



  const enabledButtons = {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true,
    insertTable: true,
    uploadImageButton: true,
    uploadVideoButton: true,
    insertEmbed: true
  };


  const AcceptanceCriteria = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} value={value} initialValues={value} workspaceId={currentWorkspaceId}
      form={form} name='acceptanceCriteria' lookupId={lookupId}
      attachments={attachementsList}
      onUpdateAttachment={updateAttachements} onSetEditorValues={v => onChange(v)}
    />;


  const Description = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} value={value} initialValues={value} lookupId={lookupId} workspaceId={currentWorkspaceId}
      form={form} name='description'
      placeholder='Add a description...'
      attachments={attachementsList}
      onUpdateAttachment={updateAttachements} onSetEditorValues={v => onChange(v)}
    />;

  const Assignees = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={profile} placeholder='Select assignee' />;


  const Reporter = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={profile} placeholder='Select reporter' />;

  const Watchers = ({ value, onChange }) =>
    <KoUserSelect mode='multiple' value={value} onChange={v => onChange(v)} users={profile} placeholder='Select watchers' />;

  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Module = ({ value, onChange }) =>
    <KoSelect
      placeholder="Select module"
      value={value}
      onChange={v => onChange(v)}
      options={modulesList?.map((module) => ({
        label: module?.name,
        value: module?.moduleId
      }))}
    />;

  // const CheckBox = ({ value, onChange }) =>
  //   <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Include in Calendar`}</Checkbox>;

  const Components = ({ value, onChange }) =>
    <KoSelect
      placeholder='Select component'
      value={value}
      onChange={v => onChange(v)}
      showSearch
      options={componentsList?.map((comp) => ({
        label: comp?.name,
        value: comp?.componentId
      }))}
    />;


  const Releases = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      placeholder='Select Tag / Release'
      options={releaseList?.map((env) => ({
        label: env?.name,
        value: env?.releaseId
      }))}
    />;

  // const debounceFetcher = useMemo(() => {
  //   const loadOptions = (value) => {
  //     pagination['search'] = value;
  //     getSpecList(pagination);
  //   };
  //   return _debounce(loadOptions, 800);
  // }, [800]);


  const SpecLink = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      mode='multiple'
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      // onSearch={debounceFetcher}
      allowClear
      placeholder='Select spec'
      options={specList?.map((sp) => ({
        label: sp?.name,
        value: sp?.documentId
      }))}
    />;



  
  // const allTimes = generateAllTimes();
  // const StarTime = ({ value, onChange }) => {
  //   return (
  //     <KoSelect
  //       value={value}
  //       onChange={onChange}
  //       showSearch
  //       allowClear
  //       placeholder="Choose Start Time"
  //       options={allTimes}
  //     />
  //   );
  // };

  // const StarTime = ({ value, onChange }) => {
  //   return (
  //     <KoSelect
  //       value={value}
  //       onChange={onChange}
  //       showSearch
  //       allowClear
  //       disabled={!endDatePicker || !startDatePicker}
  //       filterOption={(input, option) => {
  //         return option?.label?.toLowerCase().slice(0, 12).includes(input.toLowerCase());
  //       }}
  //       placeholder="Choose Time Slot"
  //       options={filteredSlots}
  //     />
  //   );
  // };

  // const Durations = ({ value, onChange }) => {
    
  //   return (
  //     <KoSelect
  //       value={value}
  //       onChange={onChange}
  //       showSearch
  //       allowClear
  //       disabled={!endDatePicker || !startDatePicker}
  //       filterOption={(input, option) => {
  //         return option?.label?.toLowerCase().slice(0, 12).includes(input.toLowerCase());
  //       }}
  //       placeholder="Choose duration"
  //       options={DURATIONSLIST}
  //     />
  //   );
  // };


  const TimeSpentSelect = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value || undefined}
        placeholder="Ex: 1w 3d 6h 20m"
        showSearch
        onChange={(v) => onChange(v)}
        options={TIMESPEND} />
    );
  };

  // const onChangeGteTicket = (value) => {
  //   let newObj = {};
  //   newObj.summary = value;
  //   newObj.issueType = 2;
  //   newObj.priority = 3;
  //   newObj.reporter = userDetails?.userId;

  //   if(!initialValues?.epicId){
  //     TaskPlannerAPI.createOrUpdateIssues(newObj, null, workspaceId).then(
  //       (data) => {
  //         getIssueById(data?.epicId, workspaceId);
  //       },
  //       (err) => {
  //       }
  //     );
  //   }
  // };

  // const Summary = ({ value, onChange }) =>
  //   <KoInput placeholder='Enter issue summary' value={value} onChange={v => onChange(v?.target?.value)} onBlur={v => onChangeGteTicket(v?.target?.value)} />;

  const SUMMARYSECTION = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'summary', placeholder: 'Enter issue summary', label: 'Summary', colSpan: 3,
        rules: [
          {
            required: true,
            message: `Please enter summary.`
          }
        ]
      },
     
      {
        key: 'status', label: 'Status', colSpan: 1.5,
        widget: TaskStatus,
        forwardRef: true
      },

      {
        key: 'lookupId', label: 'Lookup Id', colSpan: 0, className: 'metaFieldHide'
      }
    ]
  };

  const BASICMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'label1s',
        colSpan: 64,
        render() {
          return (
            <fieldset>
              <div className={styles.createdAt}>
                <legend>ISSUE DETAILS</legend>
              </div>
            </fieldset>
          );
        }
      },
      {
        key: 'sprint', colSpan: 3,
        widget: Sprint,
        forwardRef: true,
        label: 'Sprint'
      },
    
      {
        key: 'priority', label: 'Priority', colSpan: 3,
        widget: Priority,
        forwardRef: true
      },
      {
        key: 'storyPoints', label: 'Story Points / Estimate', colSpan: 3, widget: TimeSpentSelect
      },
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>PEOPLE</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'assignee', label: <div className={styles.assigneeLabel}>
          <KoText text={'Assignee'} />
          {initialValues?.assignee !== userDetails?.userId && <KoText className={styles.assignToMe} text={'(Assign to me)'} onClick={v => form.setFieldsValue({ assignee: userDetails?.userId })} />}
        </div>, colSpan: 3,
        widget: Assignees,
        forwardRef: true
      },
      {
        key: 'reporter', label: 'Reporter', colSpan: 3,
        widget: Reporter,
        rules: [
          {
            required: true,
            message: `Please select Reporter.`
          }
        ]
      },
      {
        key: 'watchers', label: 'Watchers', colSpan: 3,
        widget: Watchers
      },
      {
        key: 'customerLink', label: 'Customer', colSpan: 3,
        widget: Customers
      },
      {
        key: 'label3',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>DATE & CALENDAR</legend>
            </fieldset>
          );
        }
      },
 
      // {
      //   key: 'isCalendar',
      //   colSpan: 6,
      //   label: '',
      //   widget: CheckBox
      // },
      {
        key: 'startDate', placeholder: 'Enter Start Date', label: 'Start Date',
        colSpan: 3, widget: Date, rules: isCalendar ? [
          {
            required: true,
            message: 'Please select start date.'
          }
        ] : []
      },
      {
        key: 'endDate', placeholder: 'Enter End Date', label: 'Due Date', colSpan: 3, widget: Date,
        rules: isCalendar ? [
          {
            required: true,
            message: 'Please select end date.'
          }
        ] : []
      },
      // {
      //   key: 'duration', placeholder: '0:00', label: 'Duration', colSpan: 3,
      //   disabled: !isCalendar,
      //   widget: Durations, rules: [
      //     {
      //       required: !isCalendar ? false : true,
      //       message: `Please Pick a Time.`
      //     }
      //   ]
      // },
      // {
      //   key: 'slot', placeholder: '0:00', label: 'Pick a Slot', colSpan: 3,
      //   disabled: !isCalendar,
      //   widget: StarTime, rules: [
      //     {
      //       required: !isCalendar ? false : true,
      //       message: `Please Pick a Time.`
      //     }
      //   ]
      // },
      // {
      //   key: 'label3',
      //   colSpan: 64,
      //   render() {
      //     return (
      //       <fieldset>
      //         <legend>WORK LOG</legend>
      //       </fieldset>
      //     );
      //   }
      // },
      // {
      //   key: 'timeSpent', label: 'Time spent', colSpan: 3, widget: TimeSpentSelect
      // },
      // {
      //   key: 'timeRemaining', label: 'Time remaining', colSpan: 3, widget: TimeSpentSelect
      // },
      {
        key: 'label1a',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>ADDITIONAL INFORMATION </legend>
            </fieldset>
          );
        }
      },
      {
        key: 'specLink', label: <div className={styles.specLink}>
          <KoText text={'Spec Link'} />
        </div>, colSpan: 3, widget: SpecLink
      },
      {
        key: 'release', label: 'Tag / Release', colSpan: 3, widget: Releases
      },
      {
        key: 'module', label: 'Module', colSpan: 3, widget: Module
      },
      {
        key: 'component', label: 'Component', colSpan: 3, widget: Components
      }

      

    ]
  };

  const TASKINFOMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'acceptanceCriteria', placeholder: 'Requirement', label: 'Acceptance Criteria', colSpan: 6,
        widget: AcceptanceCriteria
      },
      {
        key: 'description', placeholder: 'Description', label: 'Description', colSpan: 6,
        widget: Description
      }

    ]
  };

  
  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { service: getCookie('wos'), module: 'taskplanner', lookupId: lookupId },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },


    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;

    // Check if all uploads have either completed or failed
      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );

      if (allFinished) {
        setLoading(true);

        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));
        updateTicektInfo(successfulFiles);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onRemoveFile = (d) => {
    setRefresh(false);
    DevelopmentAPI.deleteAttachments(currentWorkspaceId, initialValues?.lookupId, d?.uid).then(
      (data) => {
        setRefresh(true);
        dispatch(getTicketTabCount({ workspaceId: currentWorkspaceId, ticketId: initialValues?.epicId }));
      },
      (err) => {
      }
    );
  };

  const updateAttachements=(attachments, info) => {
    setAttachementsList(attachments || []);
    if(info === 'rc'){
      updateTicektInfo(attachments);
    }
  };


  return (
    <div className={`${styles.ticketWrapper} 'tabContnetTicket'`}>
      <div className={`${styles.wrapper} ${className ? className : ''}`}>
        <KoForm form={form} layout="vertical"
          onFinish={handleSubmit} onSubmit={handleSubmit}>
          <div className={styles.leftForm}>
            <KoFormBuilder form={form} meta={SUMMARYSECTION} />
            <div className={`${styles.taskInfo} profileSection`}>

              <KoTabs options={[
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='TextOutlined' width={14} height={14} /> */}
                    <KoText text={'Issue Details'} />
                  </div>,
                  children: <div className={styles.taskInfoTabs}>
                    <KoFormBuilder form={form} meta={TASKINFOMETADATA} /></div>,
                  key: 'about'
                },
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='AttachmentOutlined' width={14} height={14} /> */}
                    <KoBadge color="var(--palette-primary-main)" count={issueStates?.attachmentCount} offset={[9, 1]}>
                      <KoText text={'Attachments'} />
                    </KoBadge>
                  </div>,
                  children: <div className={`${styles.taskInfoTabs} tableCard`}>
                    <div className={`${styles.attachments}`}>
                      <KoTitle level={4} text={'Attachments'} />
                      <KoButton onClick={()=>setUploadFileModal(true)} color="purple" variant="outlined" className={'btn'} label={'Upload'} icon={<KoIcon color="#9154de" width={14} height={14} name={'AttachmentOutlined'} />} />
                    </div>
                    <Attachemnts refresh={refresh} setAttachementsList={updateAttachements} onRemoveFile={onRemoveFile} ticketId={initialValues?.epicId} workspaceId={currentWorkspaceId} />
                  </div>,
                  key: 'attachments'
                },
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='ChatOutlined' width={15} height={15} color="var(--palette-gray-10)"/> */}
                    <KoBadge color="var(--palette-primary-main)" count={issueStates?.commentsCount} offset={[9, 1]}>
                      <KoText text={'Comments'} />
                    </KoBadge>
                    {/* {initialValues?.epicId &&  <KoIcon name='PlusFilled' onClick={()=>setCreateComment(true)}/>} */}
                  </div>,
                  children: <div className={styles.worklogTab}>
                    <Comments workspaceId={initialValues?.workspace}
                      ticketId={initialValues?.epicId}
                      setCreateComment={setCreateComment}
                      lookupId={lookupId}
                      isOpenCommentsModal={isOpenCommentsModal} />
                  </div>,
                  key: 'comments',
                  disabled: (!initialValues?.epicId)
                }

                // {
                //   label: <div className={styles.subTaskTab}>
                //     {/* <KoIcon name='InfoOutlined' width={15} height={15} color="var(--palette-gray-10)"/> */}
                //     <KoBadge color="var(--palette-primary-main)" count={initialValues?.activitiesCount} offset={[9, 1]}>
                //       <KoText text={'Activities'} />
                //     </KoBadge>
                //   </div>,
                //   children: <div className={styles.taskInfoTabs}>
                //     <Activities  workspaceId={initialValues?.workspace}
                //       ticketId={initialValues?.epicId}/>
                //   </div>,
                //   key: 'activities'
                // }

              ]} />
            </div>
          </div>
          <div className={styles.rightForm}>
            <div className={styles.createdAtWrapperMain}>
              <div className={styles.createdAtWrapper}>
                <KoText text="Workspace" className={styles.createdAtText} />
                <KoTooltips title={workspace?.name ? workspace?.name : 'workspace Loading...'}>
                  <KoTag color={workspace?.color ? workspace?.color : 'blue'} value={workspace?.name ? workspace?.name : 'workspace Loading...'} />
                </KoTooltips>
              </div>
              <div className={styles.createdAtWrapperDate}>
                {initialValues?.createdAt && <div className={styles.createdAtWrapper}>
                  <KoText text="Created on" className={styles.createdAtText} />
                  <KoTag iscount={false} custom={true} color='draft' value={<KoDateFormatter className={styles.createdAtDate} data={initialValues?.createdAt} format="DD-MMM-YYYY" />} />
                </div>}
                {(initialValues?.updatedAt && initialValues?.updatedAt !== '0001-01-01T00:00:00Z') && <div className={styles.createdAtWrapper}>
                  <KoText text="Last edited on" className={styles.createdAtText} />
                  <KoTag iscount={false} custom={true} color='draft' value={<KoDateFormatter className={styles.updatedAt} data={initialValues?.updatedAt} format="DD-MMM-YYYY" />} />
                </div>}
              </div>
            </div>
            <KoFormBuilder form={form} meta={BASICMETADATA} />
          </div>
        </KoForm>
        {saveBtn &&
          <KoButton key='Update' type='primary' label='Update' onClick={() => form.submit()} className={styles.saveBtn} />
        }
      </div>
      <KoModal
        title={'Upload File'}
        centered
        open={uploadFileModal}
        handleOk={() => { setUploadFileModal(false); }}
        onClose={() => { setUploadFileModal(false); }}
        width={760}
        footer={[]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {isLoading && <KoLoader circle={false} />}
          <KoForm.Item
            name={["attachments"]}
            valuePropName={["attachments"]}
            getValueFromEvent={normFile}>
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </KoForm.Item>
        </div>
      </KoModal>
    </div>
  );
};

export default EpicTaskCrud;